var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFlightTravel40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2427_9542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8135 15.5813L28.5797 16.3604C28.9736 16.7609 29.0799 17.3629 28.8469 17.8741L27.8726 20.0103L31.2045 30.446C31.5588 31.556 31.3413 33.0222 30.7277 34.1185L30.6743 34.2067L30.5918 34.2479C29.6728 34.655 28.6666 34.3095 28.0982 33.2759L21.3239 20.9556L24.6591 18.3013C24.7559 18.2243 24.8537 18.1563 24.9519 18.0972L27.8135 15.5813Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2485 12.4401L21.6681 15.0228C21.5824 15.1573 21.4769 15.2911 21.3512 15.4225L18.4205 18.4866L6.71106 12.276C5.6866 11.7327 5.32765 10.7356 5.72889 9.81884L5.76937 9.73332L5.85509 9.68288C6.87301 9.10998 8.20877 8.8751 9.28137 9.12167L9.52396 9.18718L19.9054 12.4304L22.0219 11.5277C22.4966 11.3249 23.0454 11.4091 23.4374 11.7451L24.2485 12.4401Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2099 5.89496C35.4446 7.12962 35.4446 9.13139 34.2099 10.366C34.1892 10.3868 34.1682 10.4072 34.1469 10.4273L17.6266 26.0538L17.0944 26.5854L19.4196 34.4766L19.3712 34.525C18.3159 35.5803 16.9048 35.3515 16.2235 34.0218L12.8693 27.4789C12.8264 27.4414 12.7845 27.4022 12.7436 27.3613L12.6267 27.2338L6.08307 23.8814C4.81117 23.2297 4.5465 21.9103 5.44945 20.8732L5.57983 20.7336L5.62826 20.6852L13.5187 23.0097L14.0686 22.4607L29.6776 5.95802C30.8774 4.68952 32.8784 4.63384 34.1468 5.83363L34.2099 5.89496Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2427_9542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFlightTravel40);
export default __webpack_public_path__ + "static/media/pictogramBeaconFlightTravel40.52f5ee2ad6ded233bd49f7fc5913807a.svg";
export { ForwardRef as ReactComponent };